module.exports = __webpack_public_path__ + "media/icons/firma-grey-b4c96960.png";